import { parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'
import { RolodexEntryJson } from './rolodexEntryFields'

export class GeckoPointCloudReference {
  id: string

  constructor(id: string) {
    this.id = id
  }

  toJSON = (): Record<string, unknown> => ({
    id: this.id,
  })

  static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoPointCloudReference(json.id)
  }
}

/**
 * An entry for bundling multiple point clouds into a single scene.
 */
export class GeckoPointCloudScene extends GeckoEntryBase<
  {
    name?: string
    potree_point_clouds: Map<string, GeckoPointCloudReference>
  },
  {
    site: string
    organization: string
  }
> {
  //----------------------------------------------------------------------------

  /**
   * A simple constructor, private so that a more descriptive factory method
   * (which can return undefined) is used instead
   * @param json The raw JSON to create an instance from
   * @private
   */
  private constructor(json: RolodexEntryJson) {
    const potreePointCloudsJson = json.data.potree_point_clouds as Record<
      string,
      RolodexEntryJson
    >

    super(
      json,
      {
        name: parseString(json.data?.name) ?? undefined,
        potree_point_clouds: Object.keys(potreePointCloudsJson).reduce(
          (resultObject, id) => {
            resultObject.set(
              id,
              GeckoPointCloudReference.CreateFromJSON(potreePointCloudsJson[id])
            )
            return resultObject
          },
          new Map<string, GeckoPointCloudReference>()
        ),
      },
      {
        organization: parseString(json.tags.organization) ?? '',
        site: parseString(json.tags.site) ?? '',
      },
      {}
    )
  }

  //----------------------------------------------------------------------------

  public static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoPointCloudScene(json)
  }
}
